import React, { useState, useEffect } from 'react';
import { sixYardAxios } from '../../../sixYardAxios';
import classes from './myActivities.module.css';
import Activity from './activity/activity';

const MyActivities = () => {
    const [filter, setFilter] = useState('All'); 
    const [activities, setActivities] = useState([]); 
    const [upcomingActivities, setUpcomingActivities] = useState([]); 
    const [pastActivities, setPastActivities] = useState([]);

    useEffect(() => {
        fetchActivities();
    }, []);

    const fetchActivities = () => {
        sixYardAxios.get('/profile/activities')
            .then(res => {
                //  const past = res.data.data.past[0] || []; 
                // const upcoming = res.data.data.upcoming.data || [];
                const past = (res.data.data.past.data || []).map(activity => ({
                    ...activity,
                    filter: 'Past'
                }));
                const upcoming = (res.data.data.upcoming.data || []).map(activity => ({
                    ...activity,
                    filter: 'Upcoming'
                }));
                setPastActivities(past);
                setUpcomingActivities(upcoming);
                setActivities([...past, ...upcoming]); 
            })
            .catch(err => {
                console.error('Error fetching activities:', err);
            });
    };

    // Filter activities based on the selected filter
    const filteredActivities =
        filter === 'All'
            ? activities
            : filter === 'Upcoming'
            ? upcomingActivities
            : pastActivities;

    return (
        <div className={classes.Container}>
            <div className={classes.FilterContainer}>
                <span>Filter: </span>
                <button
                    onClick={() => setFilter('All')}
                    className={filter === 'All' ? classes.Selected : ''}
                >
                    All
                </button>
                <button
                    onClick={() => setFilter('Upcoming')}
                    className={filter === 'Upcoming' ? classes.Selected : ''}
                >
                    Upcoming
                </button>
                <button
                    onClick={() => setFilter('Past')}
                    className={filter === 'Past' ? classes.Selected : ''}
                >
                    Past
                </button>
            </div>

            <div className={classes.Activities}>
                {filteredActivities.length > 0 ? (
                    filteredActivities.map(activity => (
                        <Activity activity={activity} key={activity.id} />
                    ))
                ) : (
                    <div className={classes.NoActivities}>
                        No activities to show .
                    </div>
                )}
            </div>
        </div>
    );
};

export default MyActivities;
